import axios from 'axios';

const api = axios.create({
    //prd
    baseURL: 'https://api-prod.essentialone.com.br/auth',
    //dev
    // baseURL: 'https://b1api8u231.execute-api.us-east-1.amazonaws.com/dev/essentialOne',
    //local
    // baseURL: 'http://localhost:3000/dev/essentialOne',
    headers: {
        //local
        // 'x-api-key': '8FyuCmQbsn8BvdC2OcP0j8tHRpDGOhNf86AsXajp'
        //dev
        'x-api-key': 'sAuQc1933ram7Rsy0vbJq23zk5vqxjCW2GhAYaQY'
    }
})



export default api